const openGoogleMap = (coords: number[] | null | undefined) => {
  if (!coords?.length) return;
  const url = `https://www.google.com/maps?q=${coords[0]},${coords[1]}`;
  window.open(url, "_blank", "noopener,noreferrer");
};
export default openGoogleMap